import { Chip, LineSelector, Text } from '@bendhealth/common';

import { Patient } from '../../../../api/account/patients.type';
import { ChooseMemberSubText } from './ChooseMemberSubText';

export function ChooseCoreMemberLine({
  member,
  selectedOption,
  setSelectedOption,
  subText,
}: {
  member: Pick<Patient, 'id' | 'firstName' | 'unfinishedCoreOnboarding' | 'activeCorePlan'>;
  selectedOption: string;
  setSelectedOption: (id: string) => void;
  subText?: string;
}) {
  return (
    <LineSelector
      key={member.id}
      checked={selectedOption == member.id}
      disabled={member.activeCorePlan}
      onClick={() => {
        if (!member.activeCorePlan) {
          setSelectedOption(member.id);
        }
      }}
    >
      <div>
        <Text variant="body-4">{member.firstName}</Text>
        {subText && <ChooseMemberSubText> {subText}</ChooseMemberSubText>}
      </div>

      {member.unfinishedCoreOnboarding && (
        <Text variant="body-6" style={{ marginLeft: 'auto' }}>
          <Chip color="green-2">Finish Enrollment</Chip>
        </Text>
      )}

      {member.activeCorePlan && !member.unfinishedCoreOnboarding && (
        <div style={{ marginLeft: 'auto' }}>
          <Chip color="red-2">Enrolled</Chip>
        </div>
      )}
    </LineSelector>
  );
}
